import React from "react";
import { Alert, Box, Button, Grid } from "@mui/material";
import { UserPasswordModel } from "../../typings";
import UserPasswordDisplay from "../UserPasswordDisplay";

interface NewUserResultPanelProps {
    user: UserPasswordModel,
    emailSent: boolean,
    sendingDisabled: boolean,
    onEmailUser: () => void
}

const NewUserResultPanel: React.FC<NewUserResultPanelProps> = ({ user, emailSent, sendingDisabled, onEmailUser }: NewUserResultPanelProps) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Alert severity="success">
                    User "{user.userName}" has been created.
                </Alert>
            </Grid>
            {emailSent &&
                <Grid item xs={12}>
                    <Alert severity="info">
                        Credentials have been emailed to the user.
                    </Alert>
                </Grid>
            }
            <Grid item xs={12}>
                <UserPasswordDisplay userName={user.userName} password={user.password} />
            </Grid>
            <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onEmailUser}
                        disabled={emailSent || sendingDisabled}
                    >
                        Email User
                    </Button>
                </Box>
            </Grid>
        </Grid>
    );
}

export default NewUserResultPanel;
